import { gql } from '@apollo/client';

export const myDefaultOrganizationIdQuery = gql`
  query myDefaultOrganizationId {
    myDefaultOrganizationId
  }
`;

export const setDefaultOrganizationMutation = gql`
  mutation setDefaultOrganization($organizationId: Long) {
    setDefaultOrganization(organizationId: $organizationId)
  }
`;
